module.exports = __webpack_public_path__ + "media/images/webpage/hotels/3105/plan4-1-7802271ef36492d0173bc28dc81792ca.webp";